<template>
    <DialogRoot>
        <DialogTrigger>
            <button class="rounded-full text-[12px] h-14 bg-[#5358ec3d] text-[#5357ec] px-6 flex items-center gap-x-2">
                <Eye color="#5357ec" strokeWidth="1.2" size="18"/>
                Voir
            </button>
        </DialogTrigger>
        <DialogPortal>
                    <DialogOverlay className="fixed z-[1000] inset-0 bg-[#00000044] data-[state=open]:animate-overlayShow"/>
                    <DialogContent className="fixed text-black p-6 overflow-hidden h-screen w-[45%] z-[1001] left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-xl bg-transparent focus:outline-none data-[state=open]:animate-contentShow">
                        <div class="h-full w-full rounded-lg bg-white flex flex-col">
                            <div class="w-full px-5 py-8 border-b text-black flex items-center justify-between">
                                <DialogTitle class="font-light">Détails de l'offre</DialogTitle>
                                <DialogClose as-child><X color="#000" strokeWidth="1.2" class="cursor-pointer"/></DialogClose>
                            </div>
                            <div class="grow overflow-y-scroll px-5">
                                <div class="my-5 font-light text-black">
                                    <span class="text-[16px] font-semibold underline">Offre :</span> <span class="text-[17px]"> {{ offer.title }}</span>
                                </div>
                                <div class="font-light text-black">
                                    <p class="text-[14px] mb-3 underline">Description</p>
                                    <p>{{ offer.description }}</p>
                                </div>
                            </div>
                            <div class="w-full px-5 py-4 border-t text-black flex items-center justify-end gap-x-4">
                                <DialogClose as-child>
                                    <button type="button" class="border py-3 px-8 rounded-md">
                                        Fermer
                                    </button>
                                </DialogClose>
                                <button v-on:click="subscribOffer" :disabled="asSend" type="button" class="py-3 px-8 rounded-md text-white bg-[#5357ec]">
                                    <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                    <span v-else>Postuler</span>
                                </button>
                            </div>
                        </div>
                        <!-- <div class="h-[1px] w-full bg-[#ccc]" /> -->
                        <!-- <div class="flex items-center justify-end px-5 py-5 gap-x-5">
                            <DialogClose as-child>
                                <button type="button" class="border py-3 px-8 rounded-md">
                                    Fermer
                                </button>
                            </DialogClose>
                            <button v-on:click="createNewOffer" :disabled="asSend" type="button" class="py-3 px-8 rounded-md text-white bg-[#5357ec]">
                                <Loader2 v-if="asSend" class="animate-spin mx-auto"/>
                                <span v-else>Enregistrer</span>
                            </button>
                        </div> -->
                    </DialogContent>
                </DialogPortal>
    </DialogRoot>
</template>
<script>
import {
    Loader2,
    X,
    Eye} from "lucide-vue-next";
import {
  DialogClose,
  DialogContent,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from 'radix-vue';
import API from "@/service/API";
import Swal from 'sweetalert2';
export default {
    name: "ShowAndSubmitOffer",
    props: ['offerId','offer'],
    components:{
        Loader2,
        Eye,
        DialogClose,
        X,
        DialogContent,
        DialogOverlay,
        DialogPortal,
        DialogRoot,
        DialogTitle,
        DialogTrigger
    },
    data(){
        return {
            asSend: false
        }
    },
    methods:{
        subscribOffer(){
            this.asSend = true;
            const id = localStorage.getItem('userId')
            API.post("appliances",{
                user_id:id,
                job_id: this.offerId,
                status: "en attente"
            })
            .then((res)=>{
                if(!res.data.status) throw new Error(res.data.error);
                Swal.fire({title: 'Succès !',text: 'Action enregistré',icon: 'success'});
            })
            .catch((error)=>Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.asSend = false;
            })
        }
    }
}
</script>